import agencies from './agencies-apis'
import agencyProperties from './agency-properties-apis'
import brands from './brands-apis'
import brandHsCustomFields from './brand-hs-custom-fields-apis'
import brandLeadsExports from './brand-leads-exports-apis'
import connections from './connections-apis'
import fbPages from './fb-pages-apis'
import fbAdAccounts from './fb-ad-accounts-apis'
import leadsExports from './leads-exports-apis'
import orgs from './orgs-apis'
import xpoAdmin from './xpo-admin-locations'
import ttAdvertisers from './tt-advertisers-apis'
import systemUsers from './system-users-apis'

const Api = {
 agencies,
 agencyProperties,
 brands,
 brandHsCustomFields,
 brandLeadsExports,
 connections,
 fbAdAccounts,
 fbPages,
 leadsExports,
 orgs,
 xpoAdmin,
 ttAdvertisers,
 systemUsers
}

export default Api;
